import { Box, Tab, Tabs } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import styles from '../dentalenhancements/ComponentTypeDetails.module.css';
import PageHeader from '../../../components/PageHeader';
import useCustomerNumber from '../../../hooks/useCustomerNumber';
import useIsCorpView from '../../../hooks/useIsCorpView';

const ShipmentsWrapper = () => {
  const [tabsValue, setTabsValue] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const currentRoute = location.pathname;
  const isCorpView = useIsCorpView()
  const customerNumber = useCustomerNumber()

  const baseUrl = isCorpView ? `/corp/practice/${customerNumber}` : '/practice';

  const tabs = [
    {
      value: 'Upcoming Shipments',
      to: `${baseUrl}/shipments/upcoming`,
      label: 'Upcoming Shipments'
    },
    {
      value: 'Pending Approvals',
      to: `${baseUrl}/shipments/pending`,
      label: 'Pending Approvals'
    },
    {
      value: 'Backordered Items',
      to: `${baseUrl}/shipments/backorders`,
      label: 'Backordered Items'
    },
    {
      value: 'Shipment History',
      to: `${baseUrl}/shipments/history`,
      label: 'Shipment History'
    }
  ];

  useEffect(() => {
  const matchedTab = tabs.find((tab) => {
    if (tab.to.includes('/pending')) { // to account for optional kitId param
      return currentRoute.startsWith(tab.to);
    }
    return currentRoute === tab.to;
  });

  if (matchedTab) {
    setTabsValue(matchedTab.value);
  }
  }, [currentRoute, baseUrl]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    tabs.forEach((tab) => {
      if (newValue === tab.value) {
        navigate(tab.to);
      }
    });
  };

  return (
    <div className={styles.wrapper}>
      <PageHeader iconName={'truck'} headerName={'Shipment Status'} size={'26px'} />
      <Box>
        <Tabs value={tabsValue || false} onChange={handleChange}>
          {tabs.map((tab) => (
            <Tab key={tab.value} component={Link} {...tab} />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} />
      <Outlet />
    </div>
  );
};

export default ShipmentsWrapper;
